export var inheritFromPreviousStep = function inheritFromPreviousStep(steps) {
  if (steps.length) {
    var _steps = steps[steps.length - 1],
        timeframe = _steps.timeframe,
        timezone = _steps.timezone;
    return {
      timeframe: timeframe,
      timezone: timezone
    };
  }

  return {};
};